export default "__VITE_ASSET__d14c2c44__"